import { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import withViewport from "../Viewport/withViewport";
import styles from "./index.css";
import { isWindowDefined } from "@src/helpers/url";
import { asosGlobalNamespace, sdkGlobalNamespace } from "@template/constants";
import Button from "@template/components/Button";

const getGreetingMessage = (isLoggedIn, firstName, formatTranslation) => (
  <span className={styles.welcome}>
    {isLoggedIn
      ? formatTranslation("myaccountlinks_greeting", { name: firstName })
      : formatTranslation("myaccountlinks_asos_greeting")}
  </span>
);

const getButtonLinks = (isLoggedIn, formatTranslation) => {
  const identitySdk =
    isWindowDefined() &&
    window[asosGlobalNamespace] !== undefined &&
    window[asosGlobalNamespace][sdkGlobalNamespace] !== undefined &&
    window[asosGlobalNamespace][sdkGlobalNamespace].identity;

  if (!isLoggedIn) {
    return (
      <span className={styles.actions}>
        <Button
          theme="primary"
          classes={styles.action}
          data-testid="signin-link"
          role="link"
          onClick={e => {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.login();
          }}
        >
          {formatTranslation("myaccountlinks_sign_in_label")}
        </Button>
        <Button
          theme="secondary"
          classes={styles.action}
          data-testid="signup-link"
          role="link"
          onClick={e => {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.signUp();
          }}
        >
          {formatTranslation("myaccountlinks_sign_up_label")}
        </Button>
      </span>
    );
  }
};

class Greeter extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    formatTranslation: PropTypes.func.isRequired,
    firstName: PropTypes.string,
    lang: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    storeCode: PropTypes.string.isRequired,
    keyStoreDataversion: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      returnUrl: false
    };
  }

  componentDidMount() {
    this.setState({
      returnUrl: window.location.href
    });
  }

  render() {
    const { isLoggedIn, firstName, formatTranslation } = this.props;

    return (
      <div className={styles.container}>
        {getGreetingMessage(isLoggedIn, firstName, formatTranslation)}
        {getButtonLinks(isLoggedIn, formatTranslation)}
      </div>
    );
  }
}

export default withViewport(withTranslation(Greeter));
